import React, { useState, useEffect } from 'react'
import {
    InputBase,
    Grid,
    Button
} from "@material-ui/core";
import useStyles from "./styles";

import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
//import SearchGrid_SSP from '../../../components/table/SearchGrid';
import SearchGrid_SSP from '../../components/table/SearchGrid';
import Breadcrums from '../../components/BreadCrums/breadcrums';
import TopSpacer from '../../components/Common/spacer/TopSpacer';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { PostDataAPI } from '../../Services/APIService';
import Loader from '../../components/Loader/Loader';
import { ActionDialog } from "../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "../../components/Message/Alert";
//import AddNewBlog from '../component/addNewBlog';
import AddNewBlog from '../../pages/post/component/addNewBlog';


function AddPostAndBlogPage({ ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [editItem, setEditItem] = useState({});
    const [addNewBlogDialog, setAddNewBlogDialog] = useState(false);

    const handleActionClick = (key, item) => {
       
        if (key === "Edit") {
             debugger
            setEditItem(item);
        }
        else if (key === 'Status') {
            setEditItem(item);
        }
    }



    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }

    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const [state, setState] = useState({});
    const [blog, setBlog] = useState([]);
    const closeAddBlog = () => {
        setEditItem({});
        setAddNewBlogDialog(false);
    }
    const handleSuccessClose = (message) => {
        closeAddBlog();
        loadData();
        handleDataGridUpdate()
        showMessage("Success", message, "success", 3000);
    }
    const [postType, setPostType] = useState();

    const addBlog = (type) => {
        setAddNewBlogDialog(true);
        setPostType(type)
    }
    const deleteBlog = (item) => {
        deleteRecord(item);
    }

    const [postId, setPostId] = useState(0);

    const editBlog = (item) => {
        setEditItem(item);
        //  setPostId(item.postId)
        setPostType(item.type)
        setAddNewBlogDialog(true)
    }
    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(prev => !prev);
    }





    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataGridUpdate()
        }
    }
    // Function to clear the input field
    const handleClearInput = (name) => {
        setValue('');
        handleDataGridUpdate();
    };
    const deleteRecord = (item) => {
        showActionDialog("Are you sure you want to delete this blog?", "confirm", function () {
            setIsLoading(true);
            var params = { postId: item.postId }
            PostDataAPI("fdnpost/delete", params, true).then((result) => {
                setIsLoading(false);
                if (result.success) {
                    showMessage("Success", "Blog deleted successfully", "success", 3000);
                    loadData();
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }

            })
        });

    }
    const [totalRows, setTotalRows] = useState(50);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [sortColumn, setSortColumn] = useState('');
    const [sortOrder, setSortOrder] = useState('');

    const handleGridChange = (page, pageSize, isClearSearch, sortColumn, sortOrder) => {
        setCurrentPage(page);
        setPageSize(pageSize);
        setSortColumn(sortColumn);
        setSortOrder(sortOrder);
    }

    const loadData = () => {
        setIsLoading(true);

        const body = { isMobile: false };

        PostDataAPI("fdnmcchromicconnect/getPostsForMobile", body).then((result) => {
            if (result.success && result.data) {
                setBlog(result.data);
                handleDataGridUpdate();
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"News & Blog"} isBack={true}></Breadcrums>
                    </Grid>
                </Grid>
            </div>

            <Grid container className={classes.container}>
                <h1 className={classes.heading}>
                    News & Blog
                </h1>
            </Grid>



            <Grid row className={classes.gridHeader}>
                <div className={classes.gridActions}>
                    <Button className={classes.changeBtn} onClick={() => addBlog('News')}><AddCircleOutlineIcon style={{ marginRight: '6px' }} /> Add News</Button>
                    <Button className={classes.changeBtn} onClick={() => addBlog('Blog')}><AddCircleOutlineIcon style={{ marginRight: '6px' }} /> Add Blog</Button>

                </div>
                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}
                        autoComplete={'off'}
                    />
                </div>

            </Grid>



            <Grid row className={classes.container} >
                <SearchGrid_SSP columns="blogs"
                    list={blog}
                    noRecordMsg="No record exists"
                    Icon={true}
                    isUpdate={isDataGridUpdate}
                    filter={searchFilter}
                    onDeleteClick={deleteBlog}
                    onEditClick={editBlog}
                    totalRows={totalRows}
                    defaultPageSize={50}
                    handlePageChange={handleGridChange}

                />
            </Grid>

            {addNewBlogDialog ?
                <AddNewBlog
                    dialogOpenClose={addBlog}
                    handleClose={closeAddBlog}
                    handleSuccessClose={handleSuccessClose}
                    data={editItem}
                    postType={postType}
                ></AddNewBlog>
                : ''}
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

        </>
    )

}

export default withSnackbar(AddPostAndBlogPage);